export default class tagSelectCreate {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                destroy: '=',
                loaded: '=',
                maxItems: '='
            },
            controller: [
                '$scope', '$element', '$attrs', '$timeout', '$filter', 'Tag', 'Translate', 'Events', 'SweetAlert',
                ($scope, $element, $attrs, $timeout, $filter, Tag, Translate, Events, SweetAlert) => {
                    $timeout(() => {
                        var tagSelect = $($element).selectize({
                            valueField: 'id',
                            labelField: 'name',
                            searchField: 'name',
                            preload: true,
                            plugins: ['remove_button'],
                            maxItems: $scope.maxItems,

                            render: {
                                item: function(item, escape) {
                                    return'<div class="tag-label"><a style="color:inherit;" href="#/tag/' + item.id + '">' +
                                        escape(item.name) +
                                        '</a></div>';
                                }
                            },

                            load: (query, callback) => {

                                var findWithShared = false;

                                var tagExcept = (data) => {
                                    if ($attrs.tagException) {
                                        data = data.filter((tag) => {
                                            return tag.id != $attrs.tagException;
                                        });
                                    }

                                    return data;
                                };

                                if (! query.length) {
                                    return Tag.all().then((tags) => {
                                        callback(tagExcept(tags.data));
                                    });
                                }

                                Tag.findByName(query, findWithShared).then((tags) => {
                                    callback(tagExcept(tags))
                                });
                            },
                            create: (input, callback) => {
                                SweetAlert.swal({
                                    title: $filter('translate')('TAG:CREATE:NEW_TAG'),
                                    text: $filter('translate')('TAG_MODAL:CREATE:CREATE'),
                                    type: "info",
                                    showCancelButton: true,
                                    confirmButtonText: $filter('translate')('GLOBAL:YES'),
                                    cancelButtonText: $filter('translate')('GLOBAL:NO')
                                }, (isConfirm) => {
                                    if (isConfirm) {
                                        return Tag.store(input).then((tag) => {
                                            $timeout(() => {
                                                tagSelect[0].selectize.addOption({id: tag.data.id, name: tag.data.name});
                                                tagSelect[0].selectize.addItem(tag.data.id);
                                                tagSelect[0].selectize.unlock();
                                                callback();
                                            });
                                        }, () => {
                                            SweetAlert.swal({
                                                title: $filter('translate')('TAG:FLASH:CREATE_ERROR'),
                                                text: $filter('translate')('TAG:FLASH:DUPLICATE'),
                                                type: 'error'
                                            });

                                            tagSelect[0].selectize.unlock();
                                            callback();
                                        });
                                    } else {
                                        tagSelect[0].selectize.unlock();
                                        callback();
                                    }
                                })
                            }
                        });

                        $scope.$watch('loaded', (newVal, oldVal) => {
                            if (newVal) {
                                $timeout(() => {
                                    tagSelect[0].selectize.addOption({id: newVal.id, name: newVal.name});
                                    tagSelect[0].selectize.addItem(newVal.id);
                                });
                            }
                        });

                        // Watch for option to clear selected items
                        $scope.$watch('destroy', (newVal) => {
                            if (! newVal) {
                                return;
                            }

                            $timeout(() => {
                                tagSelect[0].selectize.clear(true);
                                tagSelect[0].selectize.blur();
                            });

                            $scope.destroy = false;
                        });
                    })
                }]
            }
        }
    }
